import { render, staticRenderFns } from "./AppLoadMoreConfig.vue?vue&type=template&id=2355fc64&scoped=true"
import script from "./AppLoadMoreConfig.vue?vue&type=script&lang=js"
export * from "./AppLoadMoreConfig.vue?vue&type=script&lang=js"
import style0 from "./AppLoadMoreConfig.vue?vue&type=style&index=0&id=2355fc64&prod&lang=scss"
import style1 from "./AppLoadMoreConfig.vue?vue&type=style&index=1&id=2355fc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355fc64",
  null
  
)

export default component.exports